export enum FilterHeadPosition {
    MOBILE_FILTER = 'position_mobile_filter',
    STANDARD_FILTER = 'position_standard_filter',
    STANDARD_FILTER_LISTING = 'position_standard_filter_listing',
    STANDARD_FILTER_MAP = 'position_standard_filter_map',
}

export enum FilterModalType {
    COLLAPSED = 'filter_modal_collapsed',
    NONE = 'none',
    FILTERS = 'filters',
    SORT = 'sort',
}

export enum FilterType {
    BATHROOMS = 'bathrooms',
    BEDROOMS = 'bedrooms',
    BOOKING_TYPES = 'booking_types',
    CANCELLATION_POLICY = 'cancellation_policy',
    FEATS = 'feats',
    OFFERS = 'offers',
    POPULAR_FILTERS = 'populars' /* Popular filter logic is on frontend side */,
    PRICES = 'prices',
    PROPERTY_TYPES = 'property_types',
    STARS = 'stars',
    SUITED = 'suited',
    TOPICS = 'topics',
}

export enum FilterCollapsedState {
    FOLD = 'fold',
    UNFOLD = 'unfold',
}

interface ChangeCurrentFilterModalState {
    activate: boolean
    filterHeadPosition: FilterHeadPosition | null
}

export type CancellationPolicyContextProps = {
    openCancellationPolicyModal: (position: FilterHeadPosition | null) => void
    changeCurrentFilterModalState: ChangeCurrentFilterModalState | false
}
